module.exports = __webpack_public_path__ + "media/images/sp-hd-sign-up-logo-1966a048610d50c39ade1fbefe5d9221.png";